/*
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, NgModule } from '@angular/core';
import { CookieBannerModule } from '@fleetmatics/ui.utilities/cookie-banner';

@Component({ template: '<utl-cookie-banner></utl-cookie-banner>' })
export class CookieBannerWrapperComponent {}

@NgModule({
  declarations: [CookieBannerWrapperComponent],
  imports: [CookieBannerModule]
})
export class CookieBannerWrapperModule {}
